var map = {
	"./icon-close-red.svg": 14265,
	"./icon-close.svg": 50516,
	"./icon-discord.svg": 11607,
	"./icon-down.svg": 82133,
	"./icon-error.svg": 21945,
	"./icon-facebook.svg": 48705,
	"./icon-filter.svg": 50401,
	"./icon-fox.svg": 63834,
	"./icon-github.svg": 47737,
	"./icon-globe.svg": 70682,
	"./icon-hamburger.svg": 65149,
	"./icon-identity-active.svg": 41414,
	"./icon-identity.svg": 32772,
	"./icon-linkin.svg": 91897,
	"./icon-lock-hover.svg": 55647,
	"./icon-lock.svg": 99592,
	"./icon-log-out-hover.svg": 1629,
	"./icon-log-out.svg": 97438,
	"./icon-medium.svg": 93713,
	"./icon-menu-outline.svg": 25964,
	"./icon-passport-active.svg": 59562,
	"./icon-passport.svg": 82905,
	"./icon-reddit.svg": 57812,
	"./icon-ref.svg": 782,
	"./icon-send.svg": 80440,
	"./icon-subtract.svg": 62299,
	"./icon-success.svg": 49512,
	"./icon-telegram.svg": 84372,
	"./icon-tick.svg": 78072,
	"./icon-ticket-active.svg": 74626,
	"./icon-ticket.svg": 113,
	"./icon-transaction-menu-hover.svg": 67405,
	"./icon-transaction-menu.svg": 74643,
	"./icon-twitter.svg": 9901,
	"./icon-user-active.svg": 99344,
	"./icon-user-pedding.svg": 71655,
	"./icon-user-reject.svg": 88076,
	"./icon-user-success.svg": 92568,
	"./icon-user.svg": 26060,
	"./icon-wallet-stn.svg": 79478,
	"./icon-wallet.svg": 74885,
	"./icon-warning.svg": 68696,
	"./icon-youtube.svg": 37853
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60151;